import React from 'react';

import Detail from '../Detail';
import Input from '../Input';
import CharacterLimitReached from './CharacterLimitReached';

const ListNameInput = ({
  value,
  onChange,
  rows = 2,
  placeholder = 'List Name',
  ...rest
}) => {
  const maxLength = 450;
  const nameLimitReached = value && value.length >= maxLength;
  return (
    <Detail label='Name'>
      <>
        <Input
          showCount
          multiline
          rows={rows}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          data-testid='list-name-input'
          maxLength={maxLength}
          status={nameLimitReached ? 'error' : ''}
          {...rest}
        />
        {nameLimitReached && <CharacterLimitReached />}
      </>
    </Detail>
  );
};

export default ListNameInput;
